<template>
    <tea-main @back="goBack">
        <template slot="nav">
            <div class="LicenseListNav">
                <div class="NavTitle">
                    <p @click="jumpEnrollList" style="cursor: pointer">注册教练员</p>
                    <router-link to="alteration_list">
                        <p class="license-btn">注册管理</p>
                    </router-link>
                    <p class="zuxie-btn license-btn">执照批次列表</p>
                </div>
               <div class="download">
                   <select v-model="search.batch_id"
                           @change="changeStatus">
                       <option v-for="(item, index) in licenseBatchList"
                               :key="index"
                               :value="item.batch_id">{{ item.batch_name }}
                       </option>
                   </select>
                   <div style="margin: 0 10px" v-if="list.length > 0" class="zuxie-btn" @click="downloadTutorialExcel">筛选项名单下载</div>
                   <div  class="zuxie-btn muchDown" v-else>筛选项名单下载</div>
                   <div class="zuxie-btn" @click="downloadMuch" v-if="isShowDownload && search.batch_id">整批次执照下载</div>
                   <div class="zuxie-btn muchDown spceialDown" v-else >整批次执照下载</div>
               </div>
            </div>
        </template>
        <template slot="main">
            <div class="LicenseListMain">
                <div class="fontRar">
                    <a class="" href="http://rescdn.yioks.cn/zuxie/cfa-zz-zt.rar" download="">
                        <h2> 中国足协执照文件字体包</h2>
                        <v-icon
                                name="download"
                        ></v-icon>
                    </a>
                </div>
                <div class="searchWrap">
                    <div class="search">
                        <div class="leisureBtn">
                            <select v-model="search.license_level"
                                    @change="changeStatus">
                                <option value="">全部级别</option>
                                <option v-for="(item, index) in licenseWaitList"
                                        :key="index"
                                        :value="item.value">{{ item.key }}
                                </option>
                            </select>
                            <select v-model="search.license_type"
                                    @change="changeLicenseTypelist">
                                <option value="">全部类型</option>
                                <option v-for="(item, index) in licenseTypeList"
                                        :key="index"
                                        :value="item.value">{{ item.key }}
                                </option>
                            </select>
                            <select v-model="search.get_the_way"
                                    @change="changeStatus"
                                    >
                                <option value="">全部领取方式</option>
                                <option v-for="(item, index) in ways"
                                        :key="index"
                                        :value="item.value">{{ item.label }}
                                </option>
                            </select>
                        </div>
                        <div class="date_picker">
                            <el-date-picker
                              style="width: 120px"
                              v-model="search.licenseEndYear"
                              type="year"
                              @change="changeTime"
                              value-format="yyyy"
                              placeholder="有效期至">
                            </el-date-picker>
                        </div>
                        <div class="wrap">
                            <input v-model.lazy="search.keywords"
                                   type="text"
                                   placeholder="请输入搜索内容"
                                   @keyup.enter="getRequest">
                            <div v-show="search.keywords!=''"
                                 class="close"
                                 @click="hideIcon">
                                <v-icon name="regular/times-circle"
                                        scale="1.2"></v-icon>
                            </div>
                            <div class="searchBtn"
                                 @click="getRequest">搜索
                            </div>
                        </div>
                    </div>
                </div>
                <yioks-loading v-show="isLoading"></yioks-loading>
                <template v-if="!isLoading">
                    <template v-if="showList">
                        <div class="table">
                            <div class="thead">
                                <div class="tr">
                                    <div class="th index"><strong>序号</strong></div>
                                    <div class="th name"><strong>姓名</strong></div>
                                    <div class="th id_number"><strong>证件号</strong></div>
                                    <div class="th license_end"><strong>执照编号</strong></div>
                                    <div class="th license_level"><strong>级别</strong></div>
                                    <div class="th phone"><strong>有效期至</strong></div>
                                    <div class="th batch"><strong>批次/执照类型</strong></div>
                                    <div class="th status"><strong>领取方式</strong></div>
                                </div>
                            </div>
                            <div class="scrollArea" v-if="showList">
                                <vue-scroll :ops="ops" ref="vs">
                                    <div class="tbodyWrap">
                                        <div class="tbody">
                                            <div class="tr"
                                                 v-for="(item, index) in list"
                                                 :key="index">
                                                <div class="td index">
                                                    <p>{{ index+1 }}</p>
    
                                                </div>
                                                <div class="td name">
                                                    <p style="cursor: pointer;color: #4cd964" @click="viewDetail(item.uid)">{{ item.user_name }}</p>
                                                </div>
                                                <div class="td id_number">
                                                    <p>{{ item.user_id_number||"--" }}</p>

                                                </div>
                                                <div class="td license_end">
                                                    <p style="cursor: pointer;color:#4cd964"  v-if="item.license_address">
                                                        <a :href="item.license_address" target="_blank">{{ item.coach_license_number  }}</a>
                                                    </p>
                                                    <p v-else>--</p>
                                                </div>
                                                <div class="td license_level">
                                                    <p :title="item.license_level | level">{{item.license_level | level}}</p>
                                                </div>
                                                <div class="td phone">
                                                    <p>{{item.license_end||'--'}}</p>
                                                </div>
                                                <div class="td batch">
                                                    <p :title="item.batch_name">{{item.batch_name}}</p>
                                                </div>
                                                <div class="td status">
                                                    <p style="cursor: pointer;color: #4cd964" v-if="item.get_the_way" @click="getLicenseWay(item.license_id)">{{item.get_the_way | status }}</p>
                                                    <p v-else>--</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </vue-scroll>
                            </div>
                        </div>
                        <div id="paging">
                            <yioks-paging :paging="paging"
                                          @goto-page="gotoPage($event)"></yioks-paging>
                        </div>
                    </template>
                    <yioks-empty v-show="showEmpty"></yioks-empty>
                </template>
                <template v-if="showLicenseFlag">
                    <license-address :showDialog.sync="showLicenseFlag" :licenseInfo="licenseInfo"></license-address>
                </template>
                <template v-if="ifDiaShow">
                    <el-dialog
                      class="detail-info-dia"
                      title="详细信息"
                      :visible.sync="ifDiaShow"
                      :close-on-click-modal="false"
                      width="750px"
                      top="12vh"
                    >
                        <div class="scroll-wrap">
                            <vue-scroll :ops="infoOps" ref="vScroll">
                                <div class="stu-info-box">
                                    <stu-detail-info :info='curStuInfo'></stu-detail-info>
                                </div>
                            </vue-scroll>
                        </div>
                    </el-dialog>
                </template>
                <el-dialog
                        class="tutorial-downloading"
                        :visible.sync="downloading"
                        :close-on-click-modal="false"
                        :show-close="false"
                        width="450px">
                    <div class="loading">
                        <el-progress type="circle"
                                     :width="110"
                                     :percentage="downloadPercent"></el-progress>
                        <p>执照正在生成中，请稍后...</p>
                    </div>
                    <div class="btn-wrap">
                        <button class="btn"
                                @click="cancelDownload">取消生成
                        </button>
                    </div>
                </el-dialog>
                <a :href="pdf_url"
                   ref="downloadA"
                   download=""
                   hidden="hidden">test</a>
            </div>
        </template>
    </tea-main>
</template>

<script>
    import {license_list,license_batch_list,license_download_all} from "@/api/system_manager/api";
    import "vue-awesome/icons/download";
    import {licenseWaitList,classLevelListForCoachAndGoalkepperForLicense, licenseTypeList} from "@/assets/js/select";
    import {LevelFilters} from "@/assets/js/status";
    import {storageData} from "@/assets/js/storage";
    import ops from '@/assets/js/vuescrollOption';
    import userImg from "@/assets/images/person.png";
    import {license_get_way_info,getStuDetailInfo} from "@/api/common/api";
    import { licenseTypeFilter } from '@/assets/js/yioksFilters';
    import commonFun from "@/assets/js/yioks";
    import qs from 'qs'
    import axios from 'axios';
    let CancelToken = axios.CancelToken;
    const { downfile } = commonFun;
    const HOSTURL = process.env.VUE_APP_URL;
    export default {
        name: "EnrollList",
        data() {
            const token = storageData.getToken();
            return {
                downloading:false,
                ways:[
                    {
                        label: '邮寄（到付）',
                        value: 'mail'
                    },
                    {
                        label: '自取',
                        value: 'invite'
                    }
                ],
                mode:'',
                getLicenseFlag:false,
                ifDiaShow:false,
                licenseInfo:{},
                showLicenseFlag:false,
                pdf_url: "",
                // licenseWaitList,
                licenseWaitList: classLevelListForCoachAndGoalkepperForLicense.slice(1),
                licenseTypeList,
                abort: null,
                pdfNum: 0,
                downloadPercent: 0,
                token,
                ops: ops(),
                infoOps: ops(true),
                licenseBatchList:[],
                isShowDownload:false,
                userImg,
                idx:0,
                stu_id:'',
                disabled:false,
                dialogVisible:false,
                imgUrl:'',
                user_id:'',
                index:0,
                statusList:[
                    {
                        name:'待审核',
                        type:'audit'
                    },{
                        name:'已确认',
                        type:'pass'
                    },{
                        name:'已拒绝',
                        type:'refused'
                    },
                    {
                        name:'待完善',
                        type:'perfect'
                    },
                    {
                        name:'暂时保存中',
                        type:'edit'
                    },

                ],
                muchList:[],
                isLoading: true,
                showList: false,
                showEmpty: false,
                list: [],
                page: 1,
                paging: {
                    start: 0,
                    prePage: 1, // 一页多少条数据
                    total: 0, // 总页数
                    size: 3, // 页码显示限制
                    last: true, // 尾页
                    next: true, // 下一页
                    first: true, // 首页
                    previous: true, // 上一页
                    jump: true
                },
                curStuInfo: {
                    studentSingnInfo: {},
                    language_list: [],
                    academic_data: [],
                    coach_data: [],
                    experience_data: [],
                    playing_data: []
                },
                search: {
                    keywords:'',
                    batch_id:'',
                    license_level:'',
                    license_type: '',
                    get_the_way:'',
                    licenseEndYear:''
                },
            }
        },
        components: {
            "tea-main": () => import("@/components/LayOut/Common/up-down"),
            "yioks-paging": () => import("@/components/Pagination/Page"),
            "yioks-empty": () => import("@/components/Tips/Empty"),
            "v-icon": () => import("vue-awesome/components/Icon"),
            "yioks-loading": () => import("@/components/Loading/Loading"),
            "license-address": () => import("@/components/GetLicense/getLicenseByOrg"),
            "yioks-verify": () => import("@/components/Tips/verify-adjust"),
            "stu-detail-info": () => import("@/components/StuDeatilInfo/StuDeatilInfo"),
        },
        computed:{
            // 开始时间日历中，禁用当前日期之前的日期
            StartOpt() {
                return {
                    disabledDate: time => {
                        if(Number(this.search.end_date)) {
                            return time.getTime() > Number(this.search.end_date)
                        }
                    }
                };
            },
            // 结束时间日历中,禁用开始时间之前的日期
            EndOpt() {
                return {
                    disabledDate: time => {
                        if(Number(this.search.start_date)) {
                            return time.getTime() < Number(this.search.start_date)
                        }
                    },
                };
            },
        },
        created() {
            this.setData();
             this.getBatchList();
            //  this.request();
            this.changeQuery(true)
        },
        filters: {
            licenseTypeFilter,
            level(level){
                return LevelFilters(level)
            },
            status(status){
                if (!status) return '--'
                switch (status) {
                    case 'mail' : status='邮寄（到付）';break;
                    case 'invite' : status='自取';break;
                }
                return status
            }
        },
        methods: {
          viewDetail(user_id) {
            this.disabled=true;
            this.getDetailInfo(user_id)
          },
          getDetailInfo(user_id) {
            getStuDetailInfo({ uuid: user_id })
            .then(({ data }) => {
              if (data.status === 0) {
                const { result } = data;
                this.curStuInfo.studentSingnInfo = {
                  ...result.studentSingnInfo,
                  id_card_photo_front: result.studentSingnInfo.id_card_photo_front
                    ? HOSTURL + result.studentSingnInfo.id_card_photo_front
                    : identify1,
                  id_card_photo_verso: result.studentSingnInfo.id_card_photo_verso
                    ? HOSTURL + result.studentSingnInfo.id_card_photo_verso
                    : identify2,
                  profile_picture: result.studentSingnInfo.profile_picture
                    ? HOSTURL + result.studentSingnInfo.profile_picture
                    : avatorImg
                };
                // for (const key in this.studentSingnInfo) {
                //     if (this.studentSingnInfo.hasOwnProperty(key)) {
                //         const element = this.studentSingnInfo[key];
                //         this.studentSingnInfo[key] = element || "--";
                //     }
                // }
                this.curStuInfo.language_list = [...result.language_list];
                this.curStuInfo.academic_data = [...result.academic_data];
                this.curStuInfo.coach_data = [...result.coach_data];
                this.curStuInfo.experience_data = [...result.experience_data];
                this.curStuInfo.experience_data_not = [...result.experience_data_not];
                this.curStuInfo.playing_data = [...result.playing_data];
                if (this.curStuInfo.studentSingnInfo.student_information === 'Active' && !this.curStuInfo.studentSingnInfo.total_score && result.experience_data_backup.length > 0 ){
                  this.curStuInfo.experience_data = [...result.experience_data_backup];
                }
                // let take_place = '';
                // if(this.curStuInfo.studentSingnInfo.take_place && this.curStuInfo.studentSingnInfo.take_place !== '无'){
                //   const temList = JSON.parse(this.curStuInfo.studentSingnInfo.take_place)
                //   temList.forEach(letTmp =>{
                //     if(letTmp){
                //       let tmp1 = letTmp[0];
                //       for(var x = 1;x<letTmp.length ; x++){
                //         if(letTmp[x]){
                //           tmp1 = tmp1 + '/' + letTmp[x] ;
                //         }
                //       }
                //       take_place = take_place + tmp1 + '，';
                //     }
                //   })
                //   take_place = take_place.substr(0, take_place.length - 1);
                //   this.curStuInfo.studentSingnInfo.take_place=take_place
                // }
  
                // let sport_experience = '';
                // if(this.curStuInfo.studentSingnInfo.sport_experience && this.curStuInfo.studentSingnInfo.sport_experience !== '无'){
                //   const temList = JSON.parse(this.curStuInfo.studentSingnInfo.sport_experience)
                //   temList.forEach(letTmp =>{
                //     if(letTmp){
                //       let tmp1 = letTmp[0];
                //       for(var x = 1;x<letTmp.length ; x++){
                //         if(letTmp[x]){
                //           tmp1 = tmp1 + '/' + letTmp[x] ;
                //         }
                //       }
                //       sport_experience = sport_experience + tmp1 + '，';
                //     }
                //   })
                //   sport_experience = sport_experience.substr(0, sport_experience.length - 1);
                //   this.curStuInfo.studentSingnInfo.sport_experience=sport_experience
                // }
  
                // let coach_experience = '';
                // if(this.curStuInfo.studentSingnInfo.coach_experience && this.curStuInfo.studentSingnInfo.coach_experience !== '无'){
                //   const temList = JSON.parse(this.curStuInfo.studentSingnInfo.coach_experience)
                //   temList.forEach(letTmp =>{
                //     if(letTmp){
                //       let tmp1 = letTmp[0];
                //       for(var x = 1;x<letTmp.length ; x++){
                //         if(letTmp[x]){
                //           tmp1 = tmp1 + '/' + letTmp[x] ;
                //         }
                //       }
                //       coach_experience = coach_experience + tmp1+ '，';
                //     }
                //   })
                //   coach_experience = coach_experience.substr(0, coach_experience.length - 1);
                //   this.curStuInfo.studentSingnInfo.coach_experience=coach_experience
                // }
                this.ifDiaShow=true;
                this.disabled=false;
              } else {
                this.$message.error(data.msg)
                this.disabled=false;
              }
            }).catch(err=>{
              this.disabled=false;
            });
          },
            getBatchList(){
                const { license_type } = this.search;
                license_batch_list({license_type}).then(res=>{
                    if (Number(res.data.status)===0){
                        const {list}=res.data.result;
                        if (list.length>0){
                            // if (Number(this.search.batch_id)===0){
                            //     this.search.batch_id=list[0].batch_id;
                            // }
                            // this.licenseBatchList=list;
                            this.licenseBatchList=[{batch_id: '',batch_name:'全部批次'}].concat(list);
                            
                        }else{
                            // this.licenseBatchList=[{batch_id:0,batch_name:'暂无批次'}]
                            this.licenseBatchList=[{batch_id:'',batch_name:'暂无批次'}]
                        }
                        this.search.batch_id=this.licenseBatchList[0].batch_id;
                    }else{
                        this.$message.error(res.data.msg)
                    }
                }).catch(err=>{
                })
            },
            setData(){
                const {page,keywords,batch_id,license_level,license_type,idx,get_the_way,licenseEndYear} = this.$route.query;
                idx &&(this.idx=idx);
                page && (this.page = page);
                keywords && (this.$set(this.search, "keywords", keywords));
                batch_id && (this.$set(this.search, "batch_id", batch_id));
                license_level && (this.$set(this.search, "license_level", license_level));
                license_type && (this.$set(this.search, "license_type", license_type));
                get_the_way && (this.$set(this.search, "get_the_way", get_the_way));
                licenseEndYear && (this.$set(this.search, "licenseEndYear", licenseEndYear));
               
            },
            goBack() {
                this.$router.push('training_course_manager');
            },
            request() {
                this.isLoading = true;
                license_list({"page": this.page, ...this.search})
                    .then(res=>{
                        if (res.data.status===0){
                            const {result} = res.data;
                            this.$set(this.paging, "prePage", result.page.page_size);
                            this.$set(this.paging, "total", result.page.total_row);
                            this.$set(this.paging, "start", (this.page - 1) * this.paging.prePage);
                            this.list = result.list;
                            this.isShowDownload=result.isShowDownload;
                            this.showList = result.list.length > 0;
                            this.showEmpty = !this.showList;
                            this.isLoading = false;
                        } else{
                            this.$message.error(res.data.msg);
                            this.isLoading = false;
                        }
                    })
                    .catch(err=>{
                        this.isLoading = false;
                        console.error(err);
                    })
            },
            getLicenseWay(id){
                if (this.getLicenseFlag) return;
                this.getLicenseFlag=true
                license_get_way_info({
                    license_id:id
                }).then(({data:{msg,status,result}})=>{
                   if(Number(status)===0){
                       this.showLicenseFlag=true
                       this.licenseInfo={...result.info}
                   }else{
                       this.$message.error(msg)
                   }
                    this.getLicenseFlag=false
                }).catch(err=>{
                    this.getLicenseFlag=false
                })
            },
            hideIcon() {
                this.$set(this.search, "keywords", "");
                this.getRequest();
            },
            getRequest() {
                this.changeQuery(true);
            },
            gotoPage: function (start) {
                this.page = parseInt(start / this.paging.prePage) + 1;
                this.changeQuery(false);
                this.$refs['vs'].scrollTo({ y: 0 });
            },
            changeQuery(flag) {
                flag && (this.page = 1);
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.page,
                        idx: this.idx,
                        keywords: this.search.keywords,
                        // info_status:this.search.info_status,
                        license_level:this.search.license_level,
                        license_type:this.search.license_type,
                        batch_id:this.search.batch_id,
                        get_the_way:this.search.get_the_way,
                        licenseEndYear:this.search.licenseEndYear,

                    }
                });
                this.request();
            },
            changeStatus(){
                this.changeQuery(true)
            },
            changeLicenseTypelist() {
                this.changeQuery(true);
                this.getBatchList();
            },
            jumpEnrollList(){
                this.$router.push('EnrollList')
            },
          changeTime(){
            this.changeQuery(true)
          },
            downloadMuch(){
                this.isShowDownload=false;
                license_download_all({
                    batch_id:this.search.batch_id
                }).then(({data})=>{
                    const {status,result,msg}=data
                    if (Number(status)===0){
                        downfile(result.file)
                    } else{
                        this.$message.error(msg)
                    }
                    this.isShowDownload=true;
                }).catch(err=>{
                    this.isShowDownload=true
                })
            },
            cancelDownload(){
                this.abort('用户取消操作')
            },
            makeProgress() {
                this.downloadPercent = 0;
                const step = Math.floor(99 / (this.list.length));
                const timer = setInterval(() => {
                    if(this.downloadPercent >= 99) {
                        clearInterval(timer);
                        return false;
                    }
                    if(this.downloadPercent + step >= 99) {
                        this.downloadPercent = 99;
                    } else {
                        this.downloadPercent += step;
                    }
                }, 1500);
            },
            downloadTutorialExcel() {
                this.list.forEach((item,index)=>{
                    if (item){
                        this.muchList.push(this.list[index].license_id)
                    }
                });
                this.downloading = true;
                this.makeProgress();
                axios.post('/api/license/license_personnel_export.json',
                    qs.stringify({license_ids:this.muchList.join(','),
                        keywords:this.search.keywords,
                        batch_id:this.search.batch_id,
                        get_the_way:this.search.get_the_way,
                        license_level:this.search.license_level,
                        license_type:this.search.license_type,
                        licenseEndYear:this.search.licenseEndYear,
                    }),
                    {
                    headers: {
                        "X-Token": this.token,
                        "X-UserType":storageData.getUserType()
                    },
                    cancelToken: new CancelToken((cancel) => {
                        this.abort = cancel;
                    }),
                })
                    .then(({data}) => {
                        if (Number(data.status) === 0) {
                            this.pdf_url = data.result.file_url;
                            this.downloadPercent = 100;
                            this.$nextTick(() => {
                                this.$refs['downloadA'].click();
                            });
                            setTimeout(() => {
                                this.downloading = false;
                            }, 800);
                        }else{
                            this.downloading = false;
                            this.$message.error(data.msg);
                        }
                        this.muchList=[];
                    })
                    .catch((err) => {
                        this.downloading = false;
                        this.muchList=[];
                        console.error(err);
                    });
            },
        }
    }
</script>
<style lang="stylus">
    @import '~@/assets/css/variable';
    .tutorial-downloading {
        .el-dialog__header {
            padding: 0;
        }
        .loading {
            position: relative;
            height: 200px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        .nowFile{
            height:120px
            font-size 16px
            text-align center
        }
        .btn-wrap {
            display: flex;
            justify-content: center;
            align-items: center;
            .btn {
                padding: 12px 20px;
                font-size: 14px;
                border-radius: 4px;
                color: $color_white;
                background-color: $color_err;
                border: none;
                outline: none;
                cursor: pointer;
            }
            .success{
                background-color $color_suc
            }
        }
    }
</style>
<style lang="stylus" scoped>
    @import "~@/assets/css/variable";
    @import "~@/assets/css/mixin";
    @import "~@/assets/css/nav_filter";
    .LicenseListNav, .LicenseListMain {
        flex: 1 1 auto;
        height: 100%;
    }
    .LicenseListNav {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 12px 0 0;
        font-size: $font_size_big;
        .main_wrap{
            display: flex
            flex: 1
            justify-content: space-between
            align-items: center
            .left, .right{
                display: flex
                align-items: center
                .btn{
                    padding: 5px 15px;
                    cursor: pointer;
                    &.active{
                        background-color: $color_suc;
                    }
                    &+.btn{
                        margin-left: 10px
                    }
                }
            }

        }

        .license-btn{
            margin-left 20px
        }
        .NavTitle{
            display flex
            justify-content center
            align-items center
        }
        .download{
            display flex
            justify-content center
            align-items center
            .muchDown{
                margin: 0 20px
                background-color: #909399;
                cursor: not-allowed;
            }
            .spceialDown{
                margin 0
            }
            select {
                width: 180px;
                 height: 36px;
                padding: 0 15px;
                font-size: $font_size_medium;
                color: $color_black;
                cursor pointer
                outline: none;
                &+select {
                    margin-left 15px
                }
            }
        }

    }

    .LicenseListMain {
        width: 100%;
        padding: 25px 0 0;
        position relative
        background-color: $block_bg_color_base;
        .fontRar{
            position absolute
            color $color_suc
            font-size 16px
            cursor pointer
            top -23px
            right  0
            a{
                display flex

            }
            h2{
                font-weight 550
                margin-right 2px
            }
        }
        .searchWrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            margin: 0 40px;
            .search {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .wrap {
                    height: 100%;
                    display flex
                    position: relative;
                    input {
                        // width: 220px;
                        width: 165px;
                        height: 100%;
                        padding: 0 20px;
                        font-size: $font_size_medium;
                        color: $color_black;
                        outline: none;
                    }
                    .close {
                        position: absolute;
                        right: 95px;
                        top: 10px;
                        color: $color_info;
                        cursor: pointer;
                    }
                    .searchBtn {
                        width: 90px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 20px;
                        background-color: $color_suc;
                        cursor: pointer;
                    }
                }
                .leisureBtn{
                    position relative
                    height: 100%;
                    display flex
                    select {
                        width: 120px;
                        // height: 100%;
                        padding: 0 15px;
                        font-size: $font_size_medium;
                        color: $color_black;
                        cursor pointer
                        outline: none;
                        &+select {
                            margin-left 15px
                        }
                    }

                }
                .date_picker{
                    .el-date-editor{
                        .el-input__inner{
                            border-radius 0
                        }
                    }
                }

            }
        }
        .table {
            width: 100%;
            margin: 30px 0 0;
            .thead, .tbody {
                border: 1px solid $color_white;
            }
            .thead {
                margin: 0 40px;
                .tr {
                    height: 45px;
                    display: flex;
                }
            }
            .scrollArea {
                height: 401px;
            }
            .tbodyWrap {
                display block
                // padding: 0 40px;
            }
            .tbody {
                display block
                margin-left auto
                margin-right auto
                width: 810px;
                max-width: 810px;
                border-top: none;
                border-bottom: none;
                .tr {
                    height: 49px;
                    display: flex;
                    border-bottom: 1px solid $color_white;
                }
            }
            .th, .td {
                height: 100%;
                flex: 1 1 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 16px;
                border-right: 1px solid $color_white;
            }
            .th:last-child, .td:last-child {
                border-right: none;
            }
            /*.td:last-child {
                color: $color_suc;
                user-select: none;
            }*/
            /*.td:first-child{
                color: $color_suc;
                user-select: none;
            }*/
            .td {
                p {
                    over_hide();
                }
                .showRecord{
                    cursor pointer
                    color $color_suc
                    width 100%
                    text-align center
                    &:last-child{
                        margin-top 5px
                    }
                }
            }
            
            .pro {
                width: 15%;
                .proImg{
                    width 60px
                    height 60px
                    border-radius 50%
                    cursor pointer
                }
                .disabled{
                    pointer-events: none;
                    cursor default
                }
            }
            .index {
                width: 5%;
            }
            .name {
                width: 12%;
            }
            .id_number {
                width: 21%;
            }
            .phone {
                width: 11%;
            }
            .batch {
                width: 14%;
            }
            .status {
                width: 9%;
                .opt{
                    color $color_suc
                    cursor pointer
                }
            }
            .license_level{
                width: 6%;
            }
            .license_end{
                width 22%
            }

        }
        #paging {
            width: 100%;
            height: 77px;
        }
    }
    .detail-info-dia
        .scroll-wrap
            display block
            height 530px
            overflow hidden
            position relative
            .stu-info-box
                display block
                padding 0 15px
                font-size $font_size_medium


.zuxie-btn
    padding 10px
</style>

